const REACH_BOTTOM_OFFSET = 80
const REACH_BOTTOM_COOLDOWN = 250

function invokeHook(vm, hookName, ...args) {
  const hook = vm && vm.$options ? vm.$options[hookName] : null
  if (typeof hook !== 'function') return
  try {
    hook.apply(vm, args)
  } catch (error) {
    const name = vm && vm.$options && vm.$options.name ? vm.$options.name : 'AnonymousComponent'
    // Keep behavior consistent with Vue: log and continue.
    console.error(`[uni-lifecycle] ${hookName} failed in ${name}`, error)
  }
}

function getRouteOptions(vm, route) {
  const currentRoute = route || (vm ? vm.$route : null) || {}
  return {
    ...(currentRoute.params || {}),
    ...(currentRoute.query || {})
  }
}

function callOnShow(vm) {
  vm.__uniCompatHidden = false
  invokeHook(vm, 'onShow')
}

function callOnHide(vm) {
  if (vm.__uniCompatHidden) return
  vm.__uniCompatHidden = true
  invokeHook(vm, 'onHide')
}

function bindReachBottom(vm) {
  if (vm.__uniReachBottomHandler || typeof window === 'undefined') return
  if (typeof vm.$options.onReachBottom !== 'function') return

  vm.__uniReachBottomBusy = false
  vm.__uniReachBottomHandler = () => {
    if (vm.__uniReachBottomBusy) return

    const doc = document.documentElement || {}
    const body = document.body || {}
    const scrollTop = window.pageYOffset || doc.scrollTop || body.scrollTop || 0
    const clientHeight = window.innerHeight || doc.clientHeight || 0
    const scrollHeight = Math.max(doc.scrollHeight || 0, body.scrollHeight || 0)

    if (scrollHeight - (scrollTop + clientHeight) > REACH_BOTTOM_OFFSET) return

    vm.__uniReachBottomBusy = true
    invokeHook(vm, 'onReachBottom')
    setTimeout(() => {
      vm.__uniReachBottomBusy = false
    }, REACH_BOTTOM_COOLDOWN)
  }

  window.addEventListener('scroll', vm.__uniReachBottomHandler, { passive: true })
}

function unbindReachBottom(vm) {
  if (!vm.__uniReachBottomHandler || typeof window === 'undefined') return
  window.removeEventListener('scroll', vm.__uniReachBottomHandler)
  vm.__uniReachBottomHandler = null
}

export function registerUniLifecycleCompat(Vue) {
  if (!Vue || registerUniLifecycleCompat.installed) return
  registerUniLifecycleCompat.installed = true

  Vue.mixin({
    beforeMount() {
      if (this.__uniCompatLoaded) return
      this.__uniCompatLoaded = true
      invokeHook(this, 'onLoad', getRouteOptions(this))
    },
    mounted() {
      invokeHook(this, 'onReady')
      callOnShow(this)
      bindReachBottom(this)
    },
    activated() {
      callOnShow(this)
      bindReachBottom(this)
    },
    deactivated() {
      callOnHide(this)
      unbindReachBottom(this)
    },
    beforeRouteUpdate(to, from, next) {
      invokeHook(this, 'onLoad', getRouteOptions(this, to))
      callOnShow(this)
      next()
    },
    beforeRouteLeave(to, from, next) {
      callOnHide(this)
      unbindReachBottom(this)
      next()
    },
    beforeDestroy() {
      unbindReachBottom(this)
      callOnHide(this)
      invokeHook(this, 'onUnload')
    }
  })
}
